module.exports = __webpack_public_path__ + "static/media/urgent_outline_small.ff03ddcb.svg";